export default ($) => {
  const filterForm = document.querySelector(".js-officeFilterForm");

  if (!filterForm) return;

  const searchInput = filterForm.querySelector('input[name="search"]');
  const officeDivisions = document.querySelectorAll(".js-officeDivision");

  // No Results HTML
  const NO_RESULTS_HTML = `
    <div class="_subhead no-results-message" style="margin-top: 40px;">
      No results. Try adapting or resetting filters.
    </div>
  `;

  searchInput.addEventListener("input", () => {
    const searchTerm = searchInput.value.trim().toLowerCase();
    let hasResults = false;

    officeDivisions.forEach((division) => {
      let divisionVisible = false;

      // Process each department inside the division
      const departments = division.querySelectorAll(".js-officeDepartment");
      departments.forEach((department) => {
        let departmentVisible = false;

        // Check the department link text
        const departmentLink = department.querySelector(".js-officeDepartmentLink");
        if (departmentLink && departmentLink.textContent.toLowerCase().includes(searchTerm)) {
          departmentVisible = true;
        }

        // Check each child office inside the department
        const offices = department.querySelectorAll(".js-office");
        offices.forEach((office) => {
          const officeText = office.textContent.toLowerCase();
          if (officeText.includes(searchTerm)) {
            departmentVisible = true;
          }
        });

        // Show or hide the department based on matches
        if (departmentVisible) {
          department.style.display = "";
          divisionVisible = true; // Mark parent division as visible
        } else {
          department.style.display = "none";
        }
      });

      // Show or hide the division based on department visibility
      if (divisionVisible) {
        division.style.display = "";
        hasResults = true; // At least one division is visible
      } else {
        division.style.display = "none";
      }
    });

    // Handle "No Results" message
    const noResultsMessage = document.querySelector(".no-results-message");
    if (!hasResults) {
      if (!noResultsMessage) {
        filterForm.insertAdjacentHTML("afterend", NO_RESULTS_HTML);
      }
    } else {
      if (noResultsMessage) {
        noResultsMessage.remove();
      }
    }
  });
}